import { LogicContext } from '@/logic/main/types';
import { openingAccountItemModal } from '@/model/account/kraken';

export const fetchAccountItemModal = async (
  context: LogicContext,
  event: {
    payload: {
      account:
        | 'deposit'
        | 'responsibleGambling'
        | 'transactionHistory'
        | 'transferToPoker';
    };
  }
) => {
  if (!event.payload.account) return;
  try {
    openingAccountItemModal(event.payload.account);
  } catch (e) {}
  return context;
};
